import { NgModule } from '@angular/core';

// Composants graphiques utilises

// Module metier utilises

// Modules Material utilises

// Autres modules externes utilises 

// Modules communs utilises

// Composants metiers

// Services metier
import { TypeHabilitationService } from './services/type-habilitation.service';

// Pipes

@NgModule({
	imports: [
	],
	providers: [
		TypeHabilitationService,
	],
	declarations: [
	],
	exports: [
	]
})
export class TypeHabilitationModule {
	constructor() { }
}